import { RootState } from '@checkout/state';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

function mapStateToProps(state: RootState, ownProps?: IntlProvider.Props): IntlProvider.Props {
  let messages;
  const { locale } = ownProps && ownProps.locale ? ownProps : state.checkout.intlData;

  if (ownProps && ownProps.locale) {
    messages = Object.assign(
      {},
      state.checkout.intlData.messages,
      ownProps.messages,
    );
  } else {
    messages = state.checkout.intlData.messages;
  }
  return { locale, messages };
}

export default connect(mapStateToProps)(IntlProvider);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/wrappers/ConnectedIntlProvider.tsx